import { CTAButtonContained, CTAButtonOutlined } from './styles';

const CTAButton = ({ variant = 'contained', text, children, ...rest }) => {
  const content = text || children;

  if (variant === 'contained') {
    return <CTAButtonContained {...rest}>{content}</CTAButtonContained>;
  }

  if (variant === 'outlined') {
    return <CTAButtonOutlined {...rest}>{content}</CTAButtonOutlined>;
  }

  return null;
};

export default CTAButton;
